import { Location } from "@angular/common";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ColumnMode } from "@swimlane/ngx-datatable";
import {
  AssigmentDealerModel,
  AssigmentService,
  CreateShippingBalanceRQ,
  ShippingBalanceService,
  ShippingListModel,
  ShippingService,
  BillService
} from "app/open-api";
import { environment } from "environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import domToImage from "dom-to-image";
import jsPDF, { jsPDFOptions } from "jspdf";
import moment from "moment";
import { DownloadPdfRQ } from 'app/open-api/model/downloadPdfRQ';
import { ShippingListRQ } from '../../open-api/model/ShippingListRQ';

@Component({
  selector: "app-shipping-balance-create",
  templateUrl: "./shipping-balance-create.component.html",
  styleUrls: ["./shipping-balance-create.component.scss"],
})
export class ShippingBalanceCreateComponent implements OnInit {
  @ViewChild("tablePrint", { static: false }) dataToExport: ElementRef;
  public searchForm: FormGroup;
  public shippings: ShippingListModel[] = [];
  public assigments: AssigmentDealerModel[] = [];
  public ColumnMode = ColumnMode;
  basicSelectedOption: number = 5;
  createShippingBalance: CreateShippingBalanceRQ;
  isGeneratingMode = false;
  today: Date = new Date();
  currenciesResumen: any[] = [];
  urlApi = environment.apiUrl;

  constructor(
    private location: Location,
    private shippingService: ShippingService,
    private assigmentService: AssigmentService,
    private spinner: NgxSpinnerService,
    private shippingbalanceService: ShippingBalanceService,
    private router: Router,
    private billService: BillService
  ) {
    this.searchForm = new FormGroup({
      shippingId: new FormControl(null, Validators.required),
    });
  }

  async ngOnInit(): Promise<void> {
    this.spinner.show();
    await this.FetchModels();
    this.spinner.hide();
  }

  async FetchModels(): Promise<void> {

    const request: ShippingListRQ = {      
    }

    await this.shippingService
      .apiShippingListGet(request)
      .toPromise()
      .then((response) => {
        this.shippings = response.list;
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!. " + error,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
          position: "top-end",
        });
      });
  }

  SearchAssigments() {
    this.spinner.show();
    this.assigmentService
      .apiAssigmentListAssigmentByShippingPost(this.searchForm.value)
      .subscribe(
        (res) => {
          this.assigments = res.list;
          this.basicSelectedOption = this.assigments.length;
          this.spinner.hide();
        },
        (error) => {
          Swal.fire({
            title: "Error!. " + error,
            icon: "error",
            showConfirmButton: false,
            timer: 2000,
            position: "top-end",
          });
          this.spinner.hide();
        }
      );
  }

  ValidateBillState() {
    var assigments = this.assigments.filter(
      (bill) => bill.billStateCatalogName !== "CERR. CONTABLEMENTE"
    );
    return assigments.length > 0;
  }

  Back(): void {
    this.location.back();
  }

  GenerateBalance() {
    this.isGeneratingMode = true;
    this.createShippingBalance = this.searchForm.value;
    const shipping = this.shippings.find(
      (shipping) => shipping.id === this.createShippingBalance.shippingId
    );
    this.createShippingBalance.shippingCode = shipping.code;
    this.createShippingBalance.billsTotal = this.assigments.length;
    this.createShippingBalance.billIds = this.assigments.map(
      (assigment) => assigment.billId
    );
    this.createShippingBalance.billsCost = this.assigments.reduce(
      (accumulator, assigment) => {
        return accumulator + assigment.billTotal;
      },
      0
    );
    this.GroupBy(this.assigments);
    this.createShippingBalance.currenciesSummary = JSON.stringify(
      this.currenciesResumen
    );
  }

  GroupBy(array: AssigmentDealerModel[]) {
    array.forEach((assigment) => {
      const currencyResumen = this.currenciesResumen.find(
        (resumen) => resumen.currencyId === assigment.currencyId
      );
      if (currencyResumen) {
        currencyResumen.currencyTotal += assigment.total;
      } else {
        this.currenciesResumen.push({
          currencyId: assigment.currencyId,
          currencyName: assigment.currencyName,
          currencyTotal: assigment.total,
        });
      }
    });
  }

  AddBalance() {
    this.spinner.show();
    this.shippingbalanceService
      .apiShippingBalanceAddPost(this.createShippingBalance)
      .subscribe(
        (res) => {
          Swal.fire({
            title: "Cierre Creado",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
            position: "top-end",
          });
          this.spinner.hide();
          this.router.navigate(["/pages/shipping-balance"]);
        },
        (error) => {
          Swal.fire({
            title: "Error!. " + error,
            icon: "error",
            showConfirmButton: false,
            timer: 2000,
            position: "top-end",
          });
          this.spinner.hide();
        }
      );
  }

  SummaryPounds() {
    return this.assigments.reduce((a, b) => a + b.billPounds, 0);
  }

  SummaryTotal() {
    return this.assigments.reduce((a, b) => a + b.billTotal, 0);
  }

  SummaryDealerTotal() {
    return this.assigments.reduce((a, b) => a + b.total, 0);
  }

  GetURLById(id: number) {
    const bill = this.assigments.find((b) => b.id === id);
    return this.urlApi + "/Bills/" + bill.billFile;
  }

  GetCodeById(id: number) {
    const bill = this.assigments.find((b) => b.billId === id);
    return bill.billCode;
  }

  DownloadPdf(billId: number){
    this.spinner.show();
    const param: DownloadPdfRQ = {
      billId: billId
    }    
    this.billService.apiDownloadPdfPost(param).subscribe(response => {
      
      const fileURL = URL.createObjectURL(response);
      window.open(fileURL, '_blank');

      Swal.fire({
        title: `El pdf se descargó satisfactoriamente.`,
        icon: 'success',
        showConfirmButton: false,
        timer: 5000,
        position: 'top'
      });

      this.spinner.hide();
    }, error => {
      //console.warn(error);
      Swal.fire({
        title: 'Error! ' + error.error,
        icon: 'error',
        showConfirmButton: false,
        timer: 5000,
        position: 'top'
      });
      this.spinner.hide();
    });   
  
  }

  printTable() {
    this.spinner.show();
    const width = this.dataToExport.nativeElement.clientWidth;
    const height = this.dataToExport.nativeElement.clientHeight + 80;
    const shippingId = this.searchForm.get("shippingId").value;
    const shipping = this.shippings.find(
      (shipping) => shipping.id === shippingId
    );
    domToImage
      .toPng(this.dataToExport.nativeElement, {
        width: width,
        height: height,
      })
      .then((result) => {
        let jsPdfOptions: jsPDFOptions = {
          orientation: width > height ? "l" : "p",
          unit: "pt",
          format: [width + 50, height + 220],
        };
        const pdf = new jsPDF(jsPdfOptions);
        pdf.addImage(result, "PNG", 25, 185, width, height);
        pdf.setFontSize(16);
        pdf.setTextColor("#131523");
        pdf.text(
          "Envio: " +
            shipping.code +
            ". Fecha del reporte: " +
            moment().format("ll"),
          25,
          115
        );
        pdf.save(shipping.code + "-" + moment().format("yyyyMMDD") + ".pdf");
        this.spinner.hide();
      })
      .catch((error) => {
        this.spinner.hide();
      });
  }
}
